export default "__VITE_ASSET__DW2PtK8e__"